module.exports = __webpack_public_path__ + "static/media/web logos_UN.3fb417ae.jpg";